var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasspayLogoHalfWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_2673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18842 7.34144C7.8153 5.87957 9.6129 4.69452 11.2035 4.69452H18.2786C18.5734 4.69452 18.6948 4.93657 18.5342 5.20426L17.4 7.09451L10.7806 21.5306C10.1234 22.9638 8.3576 24.1051 6.79765 24.1051H0.480023C0.214925 24.1051 0.0847159 23.9077 0.189191 23.6641L7.18842 7.34144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0047 6.45915C19.4227 5.48459 20.6211 4.69452 21.6814 4.69452H28.8815C29.1465 4.69452 29.2767 4.89205 29.1724 5.1357L25.2812 14.2099C24.8631 15.1845 23.6649 15.9745 22.6045 15.9745H15.4045C15.1394 15.9745 15.0092 15.777 15.1137 15.5334L19.0047 6.45915Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_2673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasspayLogoHalfWhite);
export default __webpack_public_path__ + "static/media/passpay_logo_half_white.e93cbfecbea6527874cd120c1f987bb0.svg";
export { ForwardRef as ReactComponent };